import AccountIcon from "@/app/assets/images/svg/user.svg";
import LoginForm from "@/components/Form/LoginForm/LoginForm";
import Modal from "@/components/Modal/Modal";
import { useScopedI18n } from "@/i18n/client";
import { SessionContext } from "@/lib/auth/SessionContextProvider";
import { usePathname } from "next/navigation";
import { useContext, useEffect, useState } from "react";
import AccountNav from "../AccountNav/AccountNav";
import styles from "./LoginModal.module.scss";

interface LoginModalProps {
	accountAreaConfig?: any;
}

const LoginModal = ({ accountAreaConfig }: LoginModalProps) => {
	const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
	const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
	const scopedT = useScopedI18n("form.login");
	const pathname = usePathname();
	const session = useContext(SessionContext);
	const isLoggedIn = session?.session !== null;

	useEffect(() => {
		if (isAccountMenuOpen) setIsAccountMenuOpen(false);
	}, [pathname]);

	const handleAccountIconClick = () => {
		if (isLoggedIn) {
			handleAccountMenu();
		} else {
			handleLoginModal();
		}
	};

	const handleLoginModal = () => {
		setIsLoginModalOpen(!isLoginModalOpen);
		setIsAccountMenuOpen(false);
	};

	const handleAccountMenu = () => {
		setIsAccountMenuOpen(!isAccountMenuOpen);
		setIsLoginModalOpen(false);
	};

	return (
		<div className={styles.buttonContainer}>
			<button
				type={"button"}
				className={styles.button}
				onClick={handleAccountIconClick}
				aria-label={isLoggedIn ? "Open Account Navigation" : "Open Login Form"}
			>
				<AccountIcon />
			</button>

			<Modal
				ariaLabel={scopedT("logIn")}
				contentId='login-modal'
				isOpen={isLoginModalOpen}
				toggleModal={handleLoginModal}
			>
				<LoginForm handleLoginModal={handleLoginModal} />
			</Modal>

			<AccountNav
				isOpen={isAccountMenuOpen}
				setIsOpen={setIsAccountMenuOpen}
				url={pathname}
				role={session.session?.role}
				accountAreaConfig={accountAreaConfig}
			/>
		</div>
	);
};

export default LoginModal;
